import React, { useRef, useState } from "react";
import Modal from "react-bootstrap/Modal";
import { Mensaje } from "../../mensajes2";
import { Dimmer } from "../../spinner";
import axios from "axios";
import { Input, Select, Textarea } from "../../../ui/inputs/Input";
import { DangerButton, SuccessButton } from "../../../ui/buttons/Button";
export const ModalTipoDeRentas = (props) => {
  let op = require("../../../../src/modulos/datos");
  let token = localStorage.getItem("jwtToken");

  const btnCancela = useRef();
  const [activate, setActivate] = useState(false);
  const [operacion, setOperacion] = useState();
  const txtTipo = useRef();
  const txtId = useRef();
  const txtDescripcion = useRef();
  const [tipoRenta, setTipoRenta] = useState();
  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });

  const cerrarModal = () => {
    setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
    if (
      mensaje.texto == "registro creado correctamente." ||
      mensaje.texto == "registro modificado correctamente." ||
      mensaje.texto == "registro eliminado correctamente."
    ) {
      props.onHideCancela();
    }
  };

  const salir = (e) => {
    e.preventDefault();
    blanquear();
    props.onHideCancela();
  };

  const onChange = (event) => {
    if (event.target.name === "inputDescripcion") {
      event.target.value = event.target.value.toUpperCase();
    }
    if (event.target.name === "tipoRenta") {
      setTipoRenta(event.target.value);
    }
  };

  const blanquear = () => {
    setActivate(false);
  };

  const validar = (e) => {
    e.preventDefault();
    var sigue = true;
    if (operacion !== 4) {
      if (txtDescripcion.current.value === "" || tipoRenta === "") {
        setMensaje({
          mostrar: true,
          titulo: "ERROR",
          texto: "Debe llenar todo los campos",
          icono: "error",
        });
        sigue = false;
      } else if (sigue === true) {
        selectRegTipRen(props.operacion);
      }
    }
  };

  const selectRegTipRen = (operacion) => {
    let endpoint = `${op.conexion}/api/aseo/createtiporenta/${operacion}`;
    let body;
    setActivate(true);
    body = {
      nid: parseInt(txtId.current.value),
      descri: txtDescripcion.current.value,
      tip: tipoRenta,
    };
    axios
      .post(endpoint, body, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          props.onHideRenderizar();
          if (props.operacion === 1) {
            setMensaje({
              mostrar: true,
              titulo: "Exito.",
              texto: "registro creado correctamente.",
              icono: "exito",
            });
          } else if (props.operacion === 2) {
            setMensaje({
              mostrar: true,
              titulo: "Exito.",
              texto: "registro modificado correctamente.",
              icono: "exito",
            });
          } else if (props.operacion === 3) {
            setMensaje({
              mostrar: true,
              titulo: "Exito.",
              texto: "registro eliminado correctamente.",
              icono: "exito",
            });
          }
        }
        setActivate(false);
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "ERROR",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      });
  };

  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      backdrop="static"
      keyboard={false}
      onShow={() => {
        setOperacion(props.operacion);
        console.log(props.rentas);
      }}
    >
      <Modal.Header className="col-12 m-0 px-4 py-2 d-flex justify-content-between azulGradiant rounded-top text-light">
        <h3 className="fw-bold m-0">
          {operacion === 1
            ? "Registrar Tipo de Renta Municipal."
            : operacion === 2
            ? "Editar Tipo de Renta Municipal."
            : operacion === 3
            ? "Eliminar Tipo de Renta Municipal."
            : "Consultar Tipo de Renta Municipal"}
        </h3>
        <a type = "button"
          ref={btnCancela}
          className="fw-bold fs-6 text-light"
          onClick={salir}
        >
          Salir <i className="fa fa-times ms-2"></i>
        </a>
      </Modal.Header>
      <Modal.Body className="col-12 m-0 p-2 d-flex flex-wrap">
        <h2 className="col-12 m-0 p-0 text-center fw-bold">
        Tipo de Renta Municipal
        </h2>
        <div className="col-3 m-0 mb-2 p-0">
        <Input label = 'Código:'
            disabled
            ref={txtId}
            id="inputTipRenta"
            name="inputTipRenta"
            defaultValue={
            props.rentas
                ? props.rentas.idtiporentas !== null
                ? props.rentas.idtiporentas.trim()
                : ""
                : ""
            }
        />
        </div>
        <div className="col-6 m-0 mb-2 p-0 pl-2">
        <Select label = 'Tipo:'
            ref={txtTipo}
            disabled={operacion === 1 ? false : operacion == 2 ? false : true}
            onChange={onChange}
            id="tipoRenta"
            name="tipoRenta"
            defaultValue={
            props.rentas && props.rentas.codigoimpuesto !== null
                ? props.rentas.codigoimpuesto.toString()
                : ""
            }
        >
            <option key="" value="">
            ...
            </option>
            <option key={0} value="0">
            MERCADOS
            </option>
            <option key={1} value="1">
            ALQUILER DE TIERRAS TERRENOS
            </option>
            <option key={2} value="2">
            ALQUILER DE EDIFICIOS Y LOCALES
            </option>
            <option key={3} value="3">
            ASEO URBANO
            </option>
            <option key={4} value="4">
            ECONOMIA INFORMAL
            </option>
            <option key={5} value="5">
            DISPOSICION RESIDUOS SOLIDOS
            </option>
        </Select>
        </div>
        <div className="col-12 m-0 p-0">
        <Textarea label = 'Descripción:'
            ref={txtDescripcion}
            style={{ height: 70 }}
            disabled={operacion === 1 ? false : operacion == 2 ? false : true}
            id="inputDescripcion"
            name="inputDescripcion"
            rows={1}
            defaultValue={
            props.rentas
                ? props.rentas.descripcion !== null
                ? props.rentas.descripcion.trim()
                : ""
                : ""
            }
            onKeyUp={onChange}
            onChange={onChange}
        />
        </div>
      </Modal.Body>
      <Modal.Footer>
        <SuccessButton
          onClick={validar}
          disabled={operacion === 4 ? true : false}
        >
            Aceptar
        </SuccessButton>
        <DangerButton
          ref={btnCancela}
          onClick={salir}
        >
            Cancelar
        </DangerButton>
      </Modal.Footer>
      <Mensaje
          mensaje={mensaje}
          onHide={() => {
            mensaje.titulo === "Exito."
              ? cerrarModal()
              : setMensaje({
                  mostrar: false,
                  titulo: "",
                  texto: "",
                  icono: "",
                });
          }}
        />
        <Dimmer active={activate} inverted></Dimmer>
    </Modal>
  );
};
